import {
  GESTION_OPERATIVA_UPDATE_CLIENTE_BEGIN,
  GESTION_OPERATIVA_UPDATE_CLIENTE_SUCCESS,
  GESTION_OPERATIVA_UPDATE_CLIENTE_FAILURE,
  GESTION_OPERATIVA_UPDATE_CLIENTE_DISMISS_ERROR,
} from './constants'

export function updateCliente(cliente) {
  return (dispatch) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: GESTION_OPERATIVA_UPDATE_CLIENTE_BEGIN,
    })

    const promise = new Promise((resolve, reject) => {
      const doRequest = Promise.resolve()
      doRequest.then(
        (res) => {
          dispatch({
            type: GESTION_OPERATIVA_UPDATE_CLIENTE_SUCCESS,
            data: {
              cliente,
            },
          })
          resolve(res)
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: GESTION_OPERATIVA_UPDATE_CLIENTE_FAILURE,
            data: { error: err },
          })
          reject(err)
        },
      )
    })

    return promise
  }
}

export function dismissUpdateClienteError() {
  return {
    type: GESTION_OPERATIVA_UPDATE_CLIENTE_DISMISS_ERROR,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case GESTION_OPERATIVA_UPDATE_CLIENTE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        updateClientePending: true,
        updateClienteError: null,
      }

    case GESTION_OPERATIVA_UPDATE_CLIENTE_SUCCESS:
      // The request is success
      return {
        ...state,
        updateClientePending: false,
        updateClienteError: null,
        cliente: { ...state.cliente, ...action.data.cliente },
      }

    case GESTION_OPERATIVA_UPDATE_CLIENTE_FAILURE:
      // The request is failed
      return {
        ...state,
        updateClientePending: false,
        updateClienteError: action.data.error,
        cliente: null,
      }

    case GESTION_OPERATIVA_UPDATE_CLIENTE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        updateClienteError: null,
      }

    default:
      return state
  }
}
